import { ReactElement } from 'react'

import { Button } from 'antd'
import { useTranslation } from 'react-i18next'

import { Flex } from 'components/core'
import CobaltJSLogo from 'images/logo/CobaltJSLogo'

import { requestRetryNow } from '../../connectivity'

import * as styles from './styles.module.scss'

export function ReconnectingPage(): ReactElement {
    const { t } = useTranslation()

    return (
        <Flex justifyContent="center" className={styles.page}>
            <section className={styles.card} role="status" aria-live="polite">
                <CobaltJSLogo className={styles.logo} aria-hidden />
                <h2>{t('common:reconnecting.header', 'Can’t reach Cobalt')}</h2>
                <p>
                    {t(
                        'common:reconnecting.body',
                        'Check your internet connection. We’ll keep trying and pick up where you left off.'
                    )}
                </p>
                <Button
                    type="primary"
                    className={styles.tryNow}
                    onClick={requestRetryNow}
                >
                    {t('common:reconnecting.tryNow', 'Try now')}
                </Button>
            </section>
        </Flex>
    )
}
